/**
 * Execution of Licence Ping
 * @author Rhys Lloyd
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'licence-ping';
const log = debug(MODULE_NAME);

// Dependencies
import licencePing from './index';

// Constants
const DATA_LICENCE_PING_SELECTOR = '[data-licence-ping]';

/**
 * Licence Ping execution
 */
export function exec () {
	log('Running...');

	// Gather endpoints
	const licencePingEndpointElements = document.querySelectorAll(DATA_LICENCE_PING_SELECTOR),
		licencePingEndpoints = [];

	// Extract data
	for (let i = 0; i < licencePingEndpointElements.length; i++) {
		const licencePingEndpoint = licencePingEndpointElements[i];
		licencePingEndpoints.push({
			url: licencePingEndpoint.content,
			type: licencePingEndpoint.dataset.licencePing,
		});
	}

	if (licencePingEndpoints.length) {
		log('Pinging licences for', licencePingEndpoints);
		licencePing(licencePingEndpoints);
	} else {
		log('No licences to ping.');
	}
}

export { exec as default };



// WEBPACK FOOTER //
// ./project/client/src/core/modules/licence-ping/exec.js